import { Badge, Modal, Tag } from 'antd';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, Button } from '@virlewood/board-79';
import * as React from 'react';
import {
  paymentMethodsDisplayInfo
} from '@next-is-free-monorepo/next-is-free-types';
import { apiV1 } from '../../utils/apiClient';
import { MutationOptions, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { IconCreditCardOff, IconDots, IconPlug, IconPlus, IconTrash } from '@tabler/icons-react';
import CModal from '../CModal';
import { useState } from 'react';
import BgIcon from '../../microcomponents/BgIcon';
import { NButton, NTag } from '@next-is-free-monorepo/nif-web-components';
import { BankIcon, CreditCardIcon, PlusSignIcon } from '@hugeicons/core-free-icons';
import AddPaymentMethod from './AddPaymentMethod';
import { $api } from '../../utils/openApiClient';
import { HugeiconsIcon } from '@hugeicons/react';

const PaymentMethodOverview = () => {

  const paymentMethods = $api.useSuspenseQuery('get', '/shop/payment-methods');

  const [deleteConfirm, setDeleteConfirm] = useState<undefined | string>(undefined);
  const [addPaymentMethodModalOpen, setAddPaymentMethodModalOpen] = useState(false);

  const queryClient = useQueryClient();


  const deletePaymentMethod: MutationOptions = {
    mutationKey: ['delete-payment-method'],
    mutationFn: async () => {
      return await apiV1.delete(`/shop/payment-methods/${deleteConfirm}`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey:  ['get', '/shop/payment-methods'] });
      setDeleteConfirm(undefined);
    }
  };

  const setAsDefault = $api.useMutation('put', '/shop/payment-methods/{id}/set-default', {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['get', '/shop/payment-methods'] });
    }
  });

  return (
    <div
    >
      {!paymentMethods?.data?.length ? (
        <>
          <BgIcon icon={<IconCreditCardOff />} color={'red'} />
          <h3 className={'font-medium text-red-500 mt-2'}>
            Nessun metodo di pagamento inserito
          </h3>
          <p>
            Se non inserisci un metodo di pagamento l'abbonamento sarà
            disattivato al termine della prova gratuita e il tuo negozio non
            sarà più disponibile.
          </p>
        </>
      ) : (
        <div>
          {paymentMethods?.data?.map((paymentMethod) => {
              if (paymentMethod.type === 'sepa_debit' || paymentMethod.type === 'card' || paymentMethod.type === 'link') {
                return (
                  <div className={`p-2 border rounded-xl mb-2 flex justify-between ${setAsDefault.isPending && 'bg-loading'}`} key={paymentMethod.id}>
                    <div className={'flex items-center gap-2'}>
                      <div className={`p-2 rounded-lg ${paymentMethod.is_default ? 'bg-primary' : 'bg-slate-200'}`}>
                        {paymentMethod.type === 'sepa_debit' ? (
                          <HugeiconsIcon icon={BankIcon} />
                        ) : (
                          <HugeiconsIcon icon={CreditCardIcon} />
                        )}

                      </div>
                      <p
                        className={'font-bold'}>{paymentMethodsDisplayInfo[paymentMethod.type].label} {paymentMethod.type === 'link' ? paymentMethod.link?.email: `····${paymentMethod?.[paymentMethod.type]?.last4}`}</p>
                    </div>
                    <div className={'flex items-center gap-2'}>
                      {paymentMethod.is_default && (
                        <NTag color={'info'} >Predefinito</NTag>
                      )}
                      <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                          <Button iconOnly variant={'outline'} size={'sm'} className={'rounded-full'}
                                  startIcon={'hugeicons:more-horizontal'} />
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end">
                          <DropdownMenuItem
                            disabled={paymentMethod.is_default}
                            onSelect={() => setAsDefault.mutate({ params: { path: { id: paymentMethod.id } } })}>
                            Imposta come predefinito
                          </DropdownMenuItem>
                          <DropdownMenuItem
                            variant="destructive"
                            disabled={paymentMethod.is_default}
                            onSelect={() => setDeleteConfirm(paymentMethod.id)}>
                            <IconTrash size={14} />
                            Elimina
                          </DropdownMenuItem>
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </div>
                  </div>
                );
              } else {
                return (<div />);
              }
            }
          )}
        </div>
      )}
      <div style={{ marginTop: 20, textAlign: 'right' }}>
        <NButton onClick={() => setAddPaymentMethodModalOpen(true)} hugeIcon={PlusSignIcon} color={'tertiary'}>
          Aggiungi
        </NButton>
      </div>
      <CModal mutationOptions={deletePaymentMethod} onClose={() => setDeleteConfirm(undefined)} open={!!deleteConfirm}
              icon={<IconCreditCardOff />} color={'red'}
              confirmButtonText={'Elimina'}
              title={'Eliminare metodo di pagamento?'}
              text={'Senza un metodo di pagamento valido il tuo abbonamento non potrà essere rinnovato.'}>

      </CModal>
      <Modal open={addPaymentMethodModalOpen} destroyOnHidden footer={null} onCancel={() => setAddPaymentMethodModalOpen(false)}>
        <AddPaymentMethod onSuccess={() => setAddPaymentMethodModalOpen(false)} />
      </Modal>
    </div>
  );
};
export default PaymentMethodOverview;
